const messages = {
    zh: {
        title: 'CITY OF CRIME 官方充值中心',
        language: '简体中文',
        userLevel: '等级',
        userServer: '服务器',
        switchAccount: '切换账户',
        vipBenefits: 'VIP权益',
        enterID: '请输入BOSS ID',
        login: '登录',
        loginFirst: '请先登录',
        ok: '好的',
        total: '合计',
        purchaseNow: '立即购买',
        noData: '暂无数据',
        loading: '加载中……',
        selectPaymentTips: '请选择支付方式',
        selectGoodsTips: '请选择商品',
        uidTips: '您可以在游戏内点击左上角头像按钮,找到您的UID',
        coinTips: 'C Coin可用于购买本游戏中除 C Coin以及订阅服务以外所有可充值或购买的增值服务内容。',
        orderTips: '您有尚未完成的订单',
        heading1: '福利中心',
        heading2: '优惠券',
        heading3: '充值档位',
        heading4: '选择支付方式',
        heading5: '常见充值问题FAQ',
        couponTab1: '我的优惠券',
        couponTab2: '可领取优惠券',
        couponText1: '登录后查看优惠券',
        couponText2: '已选择推荐优惠券',
        couponText3: '暂无优惠券',
        couponText4: '折扣优惠不能叠加',
        couponText5: '请选择优惠券',
        couponDescription1: '单笔充值 ≤{amount} C Coins',
        couponDescription2: '完成 1 笔订单',
        couponDescription3: '当前完成进度: {current}/{total}',
        couponDescription4: '完成首次充值',
        couponMessage1: '优惠券查询失败',
        benefitsTab1: '登录奖励',
        benefitsTab2: '累计充值',
        benefitsTab3: '首次充值',
        benefitsText1: '完成任务获得奖励',
        benefitsText2: '登录充值中心',
        benefitsText3: '累计充值 {total} 次',
        benefitsText4: '已充值 {current}/{total} 次',
        benefitsText5: '首次充值奖励',
        usingText1: '如何使用C Coins',
        usingText2: 'C Coins可用于购买游戏内除订阅以及C Coins本身以外的任何礼包。',
        orderHeader: '未完成订单',
        orderbutton: '去付款',
        orderText1: '下单时间(UTC+0)',
        orderText2: '角色',
        orderText3: '服务器',
        orderText4: '商品内容',
        orderText5: '优惠券',
        orderText6: 'C Coin返利',
        orderText7: '最终价格',
        orderText8: '订单有效期',
        orderText9: '订单号',
        orderMessage1: '下单失败了',
        paymentButton: '是，知道了',
        paymentResult1: '恭喜您！充值成功！',
        paymentResult2: '很遗憾！充值失败！',
        loginMessage1: '登录失败',
        addToDesktop: '添加到桌面',
        htmlText1: '<h3>Q1:C Coin是什么,有什么用?</h3><p>答:C Coin是City of Crime游戏内发行的货币,可以代替现金用于购买游戏中除C Coin以及订阅内容以外所有可购买的增值服务内容。</p><h3>Q2:为什么我不能使用C Coin购买礼包?or为什么我看不到C Coin商城?</h3><p>答:可能由于以下原因:</p><p>1.您并未充值过C Coin。当您的C Coin余额大于0时,方可在游戏内使用C Coin支付<br>2.您所使用的平台版本暂不支持使用C Coin支付。</p><h3>Q3:优惠券如何使用?</h3><p>答:如您拥有优惠券,将在创建订单时自动生效。同时,您也可以选择不使用优惠券进行结算。请勿重复使用优惠券,否则可能会发货失败。</p><h3>Q4:优惠券长期有效吗?</h3><p>答:每张优惠券有不同的使用期限,且有效期内仅能使用一次,请您在有效期内及时使用。</p><h3>Q5:优惠券是否与折扣共享?</h3><p>答:不共享。通常每笔订单只享受一种优惠政策,特殊情况将做另行说明。</p><h3>Q6:为什么我所使用的平台版本不支持充值C Coin?</h3><p>答:试运营阶段仅支持部分平台版本进行充值,后续会视运行情况逐渐开放,敬请期待。</p>',
        termsOfService: '服务条款',
        privacyPolicy: '隐私政策',
    },
    zh_tw: {
        title: 'CITY OF CRIME 官方儲值中心',
        language: '繁體中文',
        userLevel: '等級',
        userServer: '伺服器',
        switchAccount: '切換帳戶',
        vipBenefits: 'VIP權益',
        enterID: '請輸入BOSS ID',
        login: '登入',
        loginFirst: '請先登入',
        ok: '好的',
        total: '合計',
        purchaseNow: '立即購買',
        noData: '暫無數據',
        loading: '載入中……',
        selectPaymentTips: '請選擇支付方式',
        selectGoodsTips: '請選擇商品',
        uidTips: '您可以在遊戲內點擊左上角頭像按鈕,找到您的UID',
        coinTips: 'C Coin可用於購買本遊戲中除 C Coin以及訂閱服務以外所有可儲值或購買的增值服務內容。',
        orderTips: '您有尚未完成的訂單',
        heading1: '福利中心',
        heading2: '優惠券',
        heading3: '儲值檔位',
        heading4: '選擇支付方式',
        heading5: '常見儲值問題FAQ',
        couponTab1: '我的優惠券',
        couponTab2: '可領取優惠券',
        couponText1: '登入後查看優惠券',
        couponText2: '已選擇推薦優惠券',
        couponText3: '暫無優惠券',
        couponText4: '折扣優惠不能疊加',
        couponText5: '請選擇優惠券',
        couponDescription1: '單筆儲值 ≤{amount} C Coins',
        couponDescription2: '完成 1 筆訂單',
        couponDescription3: '當前完成進度: {current}/{total}',
        couponDescription4: '完成首次儲值',
        couponMessage1: '優惠券查詢失敗',
        benefitsTab1: '登入獎勵',
        benefitsTab2: '累計儲值',
        benefitsTab3: '首次儲值',
        benefitsText1: '完成任務獲得獎勵',
        benefitsText2: '登入儲值中心',
        benefitsText3: '累計儲值 {total} 次',
        benefitsText4: '已儲值 {current}/{total} 次',
        benefitsText5: '首次儲值獎勵',
        usingText1: '如何使用C Coins',
        usingText2: 'C Coins可用於購買遊戲內除訂閱以及C Coins本身以外的任何禮包。',
        orderHeader: '未完成訂單',
        orderbutton: '去付款',
        orderText1: '下單時間(UTC+0)',
        orderText2: '角色',
        orderText3: '伺服器',
        orderText4: '商品內容',
        orderText5: '優惠券',
        orderText6: 'C Coin返利',
        orderText7: '最終價格',
        orderText8: '訂單有效期',
        orderText9: '訂單編號',
        orderMessage1: '下單失敗了',
        paymentButton: '是，知道了',
        paymentResult1: '恭喜您！儲值成功！',
        paymentResult2: '很遺憾！儲值失敗！',
        loginMessage1: '登入失敗',
        addToDesktop: '新增到桌面',
        htmlText1: '<h3>Q1:C Coin是什麼,有什麼用?</h3><p>答:C Coin是City of Crime遊戲內發行的貨幣,可以代替現金用於購買遊戲中除C Coin以及訂閱內容以外所有可購買的增值服務內容。</p><h3>Q2:為什麼我不能使用C Coin購買禮包?or為什麼我看不到C Coin商城?</h3><p>答:可能由於以下原因:</p><p>1.您並未儲值過C Coin。當您的C Coin餘額大於0時,方可在遊戲內使用C Coin支付<br>2.您所使用的平台版本暫不支援使用C Coin支付。</p><h3>Q3:優惠券如何使用?</h3><p>答:如您擁有優惠券,將在創建訂單時自動生效。同時,您也可以選擇不使用優惠券進行結算。請勿重複使用優惠券,否則可能會發貨失敗。</p><h3>Q4:優惠券長期有效嗎?</h3><p>答:每張優惠券有不同的使用期限,且有效期內僅能使用一次,請您在有效期內及時使用。</p><h3>Q5:優惠券是否與折扣共用?</h3><p>答:不共用。通常每筆訂單只享受一種優惠政策,特殊情況將做另行說明。</p><h3>Q6:為什麼我所使用的平台版本不支援儲值C Coin?</h3><p>答:試運營階段僅支援部分平台版本進行儲值,後續會視運行情況逐漸開放,敬請期待。</p>',
        termsOfService: '服務條款',
        privacyPolicy: '隱私條款',
    },
    en: {
        title: 'CITY OF CRIME Official Purchase Center',
        language: 'English',
        userLevel: 'Lv',
        userServer: 'Server',
        switchAccount: 'Switch Accounts',
        vipBenefits: 'VIP Benefits',
        enterID: 'Enter Boss ID',
        login: 'Log In',
        loginFirst: 'Please login first',
        ok: 'Confirm',
        total: 'Total',
        purchaseNow: 'Purchase Now',
        noData: 'No Data',
        loading: 'Loading……',
        selectPaymentTips: 'Please select payment method',
        selectGoodsTips: 'Please select goods',
        uidTips: 'You can tap the avatar button in the upper left corner of the game to find your UID.',
        coinTips: 'C Coins can be used for all purchases except for subscriptions and C Coins itself.',
        orderTips: 'You have an incomplete order',
        heading1: 'Benefits Center',
        heading2: 'Coupon',
        heading3: 'Offers Available',
        heading4: 'Choose Payment Method',
        heading5: 'Purchase Issues FAQ',
        couponTab1: 'My Coupons',
        couponTab2: 'Available coupons to collect',
        couponText1: 'Log in and check your coupons',
        couponText2: 'Recommended coupons selected',
        couponText3: 'No Available Coupons',
        couponText4: 'Only one discount coupon can be used at a time',
        couponText5: 'Please select a coupon',
        couponDescription1: 'Single Purchase ≤{amount} C Coins',
        couponDescription2: '1 Order(s) Completed',
        couponDescription3: 'Current completion progress: {current}/{total}',
        couponDescription4: 'Complete First Purchase',
        couponMessage1: 'Coupon query failed',
        benefitsTab1: 'Login Rewards',
        benefitsTab2: 'Total Purchases',
        benefitsTab3: 'First Purchase',
        benefitsText1: 'Complete tasks and receive rewards',
        benefitsText2: 'Log in to the Purchase Center',
        benefitsText3: 'Make {total} Purchases',
        benefitsText4: 'Purchased {current}/{total}',
        benefitsText5: 'First Purchase Rewards',
        usingText1: 'How to Use C Coins',
        usingText2: 'C Coins can be used to purchase all in-game packs except for subscriptions and C Coins itself.',
        orderHeader: 'Incomplete Order',
        orderbutton: 'Go to Purchase',
        orderText1: 'Order time (UTC+0)',
        orderText2: 'Character',
        orderText3: 'Server',
        orderText4: 'Item Contents',
        orderText5: 'Coupon',
        orderText6: 'C Coin Rebate',
        orderText7: 'Final Price',
        orderText8: 'Order Validity Period',
        orderText9: 'Order number',
        orderMessage1: 'Ordering failed',
        paymentButton: 'Got it',
        paymentResult1: 'Congratulations! Purchase successful!',
        paymentResult2: 'Unforunately, the purchase has failed!',
        loginMessage1: 'Login failed',
        addToDesktop: 'Add to desktop',
        htmlText1: "<h3>Q1: What is a C Coin, and what is it used for?</h3><p>A: C Coins are an in-game currency for City of Crime that can be used for all purchases except subscriptions and C Coins itself.</p><h3>Q2: Why can't I use C Coins to purchase packs? Why can't I find the C Coin Shop?</h3><p>Possible reasons:</p><p>1. You have never purchased C Coins before. When your C Coin balance is greater than 0, you can use C Coins to make purchases in the game.<br>2. Your platform version does not currently support C Coin payments.</p><h3>Q3: How can I use coupons?</h3><p>A: If you have a coupon, it will take effect when creating an order. You can also choose to pay without using coupons.Please do not reuse coupons. This will result in a failure to send.</p><h3>Q4: Do coupons expire?</h3><p>A: Every coupon has a different expiration date and can only be used within the validity period. Please make sure to use coupons before they expire.</p><h3>Q5: Can coupons be used in combination with discounts?</h3><p>A: No. In most cases, you may only use one discount or coupon per order. Special cases are dealt with separately.</p><h3>Q6: Why does the platform version I am using not support C Coin payments?</h3><p>A: During the current trial phase, only certain platform versions support purchasing C Coins. More platforms will gradually become available based on the future situation. Please stay tuned.</p>",
        termsOfService: 'Terms of Service',
        privacyPolicy: 'Privacy Policy',
    },
    de: {
        title: 'CITY OF CRIME Offizielles Aufladezentrum',
        language: 'Deutsch',
        userLevel: 'Level',
        userServer: 'Server',
        switchAccount: 'Konto wechseln',
        vipBenefits: 'VIP-Vorteile',
        enterID: 'Bitte geben Sie Boss-UID ein',
        login: 'Einloggen',
        loginFirst: 'Bitte loggen Sie sich zuerst ein',
        ok: 'OK',
        total: 'Gesamt',
        purchaseNow: 'Jetzt kaufen',
        noData: 'Keine Daten',
        loading: 'Laden……',
        selectPaymentTips: 'Bitte wählen Sie die Zahlungsart',
        selectGoodsTips: 'Bitte wählen Sie Waren',
        uidTips: 'Boss-UID finden Sie im Spiel unter Avatar',
        coinTips: 'C-Münzen werden für den Kauf aller In-Spiel-Paket verwendet (Außer Abonnements)',
        orderTips: 'Sie haben unvollendete Bestellungen',
        heading1: 'Vorteile',
        heading2: 'Gutschein',
        heading3: 'Aufladeoptionen',
        heading4: 'Wähle Ihre Zahlungsmethode',
        heading5: 'FAQ zum Aufladen',
        couponTab1: 'Meine Gutscheine',
        couponTab2: 'Beanspruchbare Gutscheine',
        couponText1: 'Loggen Sie sich ein, um die Gutscheine zu überprüfen',
        couponText2: 'Empfohlene Gutscheine ausgewählt',
        couponText3: 'Keine verfügbaren Gutscheine',
        couponText4: 'Gutscheine können nicht zusammen benutzt werden',
        couponText5: 'Bitte wählen Sie einen Gutschein',
        couponDescription1: 'Kaufbetrag ≤{amount} C-Münzen',
        couponDescription2: 'Schließen Sie 1 Bestellung(en) ab',
        couponDescription3: 'Aktueller Abschluss: {current}/{total}',
        couponDescription4: 'Erste Aufladung abschließen',
        couponMessage1: 'Coupon-Abfrage fehlgeschlagen',
        benefitsTab1: 'Anmelde-Belohnung',
        benefitsTab2: 'Gesamter Aufladungsbetrag',
        benefitsTab3: 'Erste-Aufladung',
        benefitsText1: 'Schlieẞen Sie Aufgaben zum Erhalten der Belohnungen ab',
        benefitsText2: 'Loggen Sie sich in Aufladezetrum ein',
        benefitsText3: '{total}-mal aufladen',
        benefitsText4: 'Aufgeladen {current}/{total}',
        benefitsText5: 'Erste-Aufladung-Belohnung',
        usingText1: 'Wie benutzt man C-Münzen?',
        usingText2: 'C-Münzen werden für den Kauf aller In-Spiel-Paket verwendet (Außer Abonnements)',
        orderHeader: 'Unerledigte Aufträge',
        orderbutton: 'Bezahlen',
        orderText1: 'Bestellzeit (UTC+0)',
        orderText2: 'Charakter',
        orderText3: 'Server',
        orderText4: 'Inhalte',
        orderText5: 'Gutscheine',
        orderText6: 'C-Münzen-Rabatt',
        orderText7: 'Endpreis',
        orderText8: 'Ablaufdatum der Bestellung',
        orderText9: 'Bestellnummer',
        orderMessage1: 'Bestellung fehlgeschlagen',
        paymentButton: 'Okay',
        paymentResult1: 'Gratulation! Die Aufladung war erfolgreich!',
        paymentResult2: 'Öps! Die Aufladung ist fehlgeschlagen!',
        loginMessage1: 'Anmeldung fehlgeschlagen',
        addToDesktop: 'Zum Desktop hinzufügen',
        htmlText1: '<h3>F1: Wofür werden die C-Münzen verwendet?</h3><p>A:C-Münzen werden für den Kauf aller In-Spiel-Paket von City of Crime verwendet (Außer Abonnements)</p><h3>F2: Warum kann ich keine C-Münzen benutzen, um Pakete zu kaufen? Warum finde ich keinen C-Münze-Laden?</h3><p>A: Es könnte daran liegen:</p><p>1. Sie haben noch nicht einmal aufgeladen. Liegt die Anzhal Ihrer C-Münzen bei mehr als 0, können Sie In-Spiel-Käufe mit C-Münzen tätigen.<br>2. Ihre aktuelle Plattform unterstützt nicht die C-Münzen.</p><h3>F3: Wie verwende ich die Gutscheine?</h3><p>A: Wenn Sie Gutscheine zur Verfügung haben, werden diese automatisch verwendet, wenn Sie eine Bestellung aufgeben. Sie können trotzdem die Gutscheine nicht verwenden.</p><h3>F4: Wie lange sind meine Gutscheine gültig?</h3><p>A: Jeder Gutschein hat eine eigene Gültigkeitsdauer und kann innerhalb dieser nur einmal eingelöst werden.</p><h3>F5: Kann ich Gutscheine mit Rabatten kombinieren?</h3><p>A: Nein. Grundsätzlich gilt nur eine Rabattmethode für eine Bestellung.</p><h3>F6: Warum unterstützt meine Plattform das Aufladen von C-Münzen nicht?</h3><p>A: Im Moment unterstützen wir nur einige Plattformen. Bitte gedulden Sie sich!</p>',
        termsOfService: 'Nutzungsbedingungen',
        privacyPolicy: 'Datenschutzrichtlinie',
    },
    fr: {
        title: 'Centre de Recharge Officiel de CITY OF CRIME',
        language: 'Français',
        userLevel: 'Niveau',
        userServer: 'Serveur',
        switchAccount: 'Handoff',
        vipBenefits: 'Avantages VIP',
        enterID: 'Veuillez entrer le BOSS ID',
        login: 'Se connecter',
        loginFirst: 'Veuillez vous connecter en premier',
        ok: "D'accord",
        total: 'Total',
        purchaseNow: 'Acheter maintenant',
        noData: 'Aucune donnée disponible',
        loading: 'Dans le chargement……',
        selectPaymentTips: 'Veuillez sélectionner un mode de paiement',
        selectGoodsTips: 'Veuillez sélectionner des marchandises',
        uidTips: "Vous pouvez trouver votre UID en cliquant sur le bouton d'avatar en haut à gauche de l'écran dans le jeu.",
        coinTips: "Les C Coins peuvent être utilisés pour acheter tout contenu des services additionnels, à l'exception des C Coins et des abonnements.",
        orderTips: 'Vous avez des commandes non finalisées',
        heading1: 'Centre des avantages',
        heading2: 'Coupon',
        heading3: 'Options de Recharge',
        heading4: 'Choisir le mode de paiement',
        heading5: 'Questions Fréquentes sur les Recharges',
        couponTab1: 'Mes coupons',
        couponTab2: 'Coupons disponibles',
        couponText1: 'Consultez les coupons après la connexion',
        couponText2: 'Offres recommandées choisies',
        couponText3: 'Pas de coupons disponibles',
        couponText4: 'Les réductions ne sont pas cumulables',
        couponText5: 'Veuillez sélectionner un coupon',
        couponDescription1: 'Recharge unique ≤{amount} C Coins',
        couponDescription2: 'Compléter 1 commandes',
        couponDescription3: "Progression actuelle de l'achèvement: {current}/{total}",
        couponDescription4: 'Effectuer la première recharge',
        couponMessage1: 'La requête de coupon a échoué',
        benefitsTab1: 'Récompenses de connexion',
        benefitsTab2: 'Recharge Cumulée',
        benefitsTab3: 'Première recharge',
        benefitsText1: 'Recevoir des récompenses pour avoir accompli des tâches',
        benefitsText2: 'Se connecter au centre de recharge',
        benefitsText3: 'Recharge Cumulée : {total} fois',
        benefitsText4: 'Recharge effectuée {current}/{total} fois',
        benefitsText5: 'Récompenses de première recharge',
        usingText1: 'Comment utiliser les C Coins',
        usingText2: "Les C Coins peuvent être utilisés pour acheter tout contenu en jeu, à l'exception des abonnements et des C Coins eux-mêmes.",
        orderHeader: 'Commandes non finalisées',
        orderbutton: 'Passer au paiement',
        orderText1: 'Heure de la commande (UTC+0)',
        orderText2: 'Personnage',
        orderText3: 'Serveur',
        orderText4: "Contenu de l'article",
        orderText5: 'Coupon',
        orderText6: 'Remise en C Coins',
        orderText7: 'Prix final',
        orderText8: 'Validité de la commande',
        orderText9: 'numéro de série',
        orderMessage1: 'La commande a échoué',
        paymentButton: "J'ai compris.",
        paymentResult1: 'Félicitations ! Recharge réussie !',
        paymentResult2: 'Malheureusement, la recharge a échoué !',
        loginMessage1: 'La connexion a échoué',
        addToDesktop: 'Ajouter au bureau',
        htmlText1: "<h3>Q1 : Qu'est-ce que les C Coins et à quoi servent-ils ?</h3><p>R : Les C Coins sont une monnaie en jeu de City of Crime qui peut être utilisée à la place de l'argent pour acheter tout contenu des services additionnels, à l'exception des C Coins et des abonnements.</p><h3>Q2 : Pourquoi ne puis-je pas utiliser les C Coins pour acheter des sacs-cadeaux ou pourquoi ne vois-je pas la boutique de C Coins ?</h3><p>R : Cela peut être dû à plusieurs raisons :</p><p>1. Vous n'avez jamais rechargé de C Coins. Vous pouvez utiliser les C Coins en jeu lorsque votre solde est supérieur à 0.<br>2. La version de la plateforme que vous utilisez ne prend pas encore en charge les paiements en C Coins.</p><h3>Q3 : Comment utiliser les coupons ?</h3><p>R : Si vous avez des coupons, ils s'appliqueront automatiquement lors de la création d'une commande. Vous pouvez également choisir de ne pas utiliser de coupon lors du règlement.N'utilisez pas les coupons de manière répétée, cela pourrait entraîner des échecs de livraison.</p><h3>Q4 : Les coupons sont-ils valables en permanence ?</h3><p>R : Chaque coupon a une période de validité différente et ne peut être utilisé qu'une seule fois pendant sa période de validité. Veuillez les utiliser à temps.</p><h3>Q5 : Les coupons sont-ils cumulables avec les remises ?</h3><p>R : Ils ne sont pas cumulables. Généralement, chaque commande bénéficie d'une seule politique de réduction. Des cas spéciaux seront expliqués séparément.</p><h3>Q6 : Pourquoi la version de la plateforme que j'utilise ne prend-elle pas en charge les recharges en C Coins ?</h3><p>R : Pendant la phase de test, seules certaines versions de plateformes sont prises en charge pour les recharges. Les options seront progressivement étendues en fonction de la situation opérationnelle. Merci de votre patience.</p>",
        termsOfService: 'Conditions de service',
        privacyPolicy: 'Politique de confidentialité',
    },
    tr: {
        title: 'CITY OF CRIME Resmi Yükleme Merkezi',
        language: 'Türkçe',
        userLevel: 'Sv',
        userServer: 'Sunucu',
        switchAccount: 'Hesap Değiştir',
        vipBenefits: 'VIP Hakları',
        enterID: "Patron ID'i girin",
        login: 'Giriş yap',
        loginFirst: 'Lütfen ilk girin',
        ok: 'Tamam',
        total: 'Toplam',
        purchaseNow: 'Hemen al',
        noData: 'Bilgi yok',
        loading: 'Yüklenmek……',
        selectPaymentTips: 'Lütfen ödeme yöntemini seçin',
        selectGoodsTips: 'Lütfen mal seçin',
        uidTips: "Oyun içinde sol üst köşede bulunan profil resminize tıklayarak UID'nizi bulabilirsiniz.",
        coinTips: 'C Coin, Oyun içinde C Coin ve abonelik hizmetleri hariç, satın alınabilir tüm artı değerli hizmetleri satın almak için kullanılabilir.',
        orderTips: 'Bekleyen siparişleriniz var',
        heading1: 'Refah Merkezi',
        heading2: 'Kupon',
        heading3: 'Yükleme seviyeleri',
        heading4: 'Ödeme türünü seçin',
        heading5: 'Sıkça Sorulan Sorular - SSS',
        couponTab1: 'Kuponlarım',
        couponTab2: 'alınabilir kopun',
        couponText1: 'Giriş yaptıktan sonra kuponları kontrol edebilirsiniz',
        couponText2: 'Tavsiye edilen indirim seçildi',
        couponText3: 'Kullanılabilir indirim yok',
        couponText4: 'İndirim indirimleri birleştirilemez',
        couponText5: 'Lütfen bir kupon seçin',
        couponDescription1: 'Tek şarj ≤{amount} C Coins',
        couponDescription2: '1 siparişlerini tamamladı',
        couponDescription3: 'Şimdiki tamamlama ilerlemesi: {current}/{total}',
        couponDescription4: 'İlk yüklemeyi tamamlayın',
        couponMessage1: 'Kupon sorguları başarısız oldu',
        benefitsTab1: 'Giriş ödülü',
        benefitsTab2: 'Toplam yükleme',
        benefitsTab3: 'İlk yükleme yapın',
        benefitsText1: 'Ödül almak için görevleri tamamlayın',
        benefitsText2: 'Yükleme Merkezine giriş yapın',
        benefitsText3: '{total} kez yükleme yapın',
        benefitsText4: '{current}/{total} kez yükleme yaptınız',
        benefitsText5: 'İlk yükleme ödülü',
        usingText1: 'C Coins nasıl kullanabilirim?',
        usingText2: 'C Coin, Oyun içinde C Coin ve abonelik hizmetleri hariç, tüm paketler satın almak için kullanılabilir.',
        orderHeader: 'Bekleyen siparişleriniz',
        orderbutton: 'Ödeme yap',
        orderText1: 'Sipariş zamanı (UTC+0)',
        orderText2: 'Rol',
        orderText3: 'Sunucu',
        orderText4: 'Ürün içeriği',
        orderText5: 'Kupon',
        orderText6: 'C Coin geri ödemesi',
        orderText7: 'Son fiyat',
        orderText8: 'Sipariş geçerlilik süresi',
        orderText9: 'seri numarası',
        orderMessage1: 'Düzenleme başarısız oldu',
        paymentButton: 'Tamam, anladım.',
        paymentResult1: 'Tebrikler! Başarıyla para eklendi!',
        paymentResult2: 'Maalesef, Para eklenmemiş!',
        loginMessage1: 'Giriş başarısız oldu',
        addToDesktop: 'Masaüstüne ekle',
        htmlText1: "<h3>S1: C Coin nedir ve ne işe yarar?</h3><p>Cevap: C Coin, City of Crime oyunu içinde kullanılan bir para birimidir. Oyun içinde C Coin ve abonelik hizmetleri hariç, satın alınabilir tüm artı değerli hizmetleri satın almak için kullanılabilir.</p><h3>S2: Neden C Coin ile hediye paketi satın alamıyorum? veya Neden C Coin Mağazası'nı göremiyorum?</h3><p>Cevap: Olası nedenler şunlar olabilir:</p><p>1.C Coin yüklemediyseniz, C Coin bakiyeniz 0'dan büyük olduğunda C Coin kullanarak ödeme yapabilirsiniz.<br>2.Kullandığınız platform sürümü C Coin ödemeyi desteklemiyor olabilir.</p><h3>S3: İndirim kuponlarını nasıl kullanabilirim?</h3><p>Cevap: İndirim kuponunuz varsa, sipariş oluştururken otomatik olarak uygulanır. Aynı zamanda, indirim kuponunu kullanmadan da ödeme yapabilirsiniz. Lütfen indirim kuponunu tekrar tekrar kullanmayın, aksi takdirde teslimat başarısız olabilir.</p><h3>S4: İndirim kuponları uzun süreli mi geçerlidir?</h3><p>Cevap: Her bir indirim kuponunun farklı bir kullanım süresi vardır ve geçerlilik süresi içinde yalnızca bir kez kullanılabilir. Lütfen geçerlilik süresi içinde kullanmaya özen gösterin.</p><h3>S5: İndirim kuponları indirimle birleştirilebilir mi?</h3><p>Cevap: Birleştirilemez. Genellikle her sipariş sadece bir tür indirim politikası alır, özel durumlar ayrıca belirtilir.</p><h3>S6: Neden kullandığım platform sürümü C Coin yükleme desteklemiyor?</h3><p>Cevap: Deneme işletme aşamasında yalnızca belirli platform sürümleri C Coin yükleme işlemini destekler, ilerleyen süreçte işletme durumuna göre aşamalı olarak genişleyecektir, sabırsızlıkla bekleyiniz.</p>",
        termsOfService: 'Hizmet Şartları',
        privacyPolicy: 'Gizlilik Politikası',
    },
    ru: {
        title: 'Центр пополнения CITY OF CRIME',
        language: 'Русский',
        userLevel: 'Уровень',
        userServer: 'Сервер',
        switchAccount: 'Передача',
        vipBenefits: 'ПРЕИМУЩЕСТВА VIP',
        enterID: 'Пожалуйста, введите BOSS ID',
        login: 'Войти',
        loginFirst: 'Пожалуйста, войдите.',
        ok: 'Подтвердить',
        total: 'Итого',
        purchaseNow: 'Купить сейчас',
        noData: 'Нет данных',
        loading: 'Загрузка в……',
        selectPaymentTips: 'Пожалуйста, выберите способ оплаты.',
        selectGoodsTips: 'Пожалуйста, выберите товары',
        uidTips: 'Вы можете нажать на аватар в левом верхнем углу главного экрана игры, чтобы найти свой UID.',
        coinTips: 'C-монеты можно использовать для покупки всех дополнительных услуг, кроме подписки и самих C Coins.',
        orderTips: 'У вас есть заказ, который еще не выполнен',
        heading1: 'Центр льгот',
        heading2: 'Купон',
        heading3: 'Варианты покупки',
        heading4: 'Выберите способ оплаты',
        heading5: 'Часто задаваемые вопросы по вопросам покупки',
        couponTab1: 'Мои купоны',
        couponTab2: 'Купоны доступны',
        couponText1: 'Войдите, чтобы проверить свои купоны',
        couponText2: 'Выбраны рекомендуемые купоны',
        couponText3: 'Доступных купонов нет',
        couponText4: 'Купоны нельзя использовать в сочетании со скидками',
        couponText5: 'Пожалуйста, выберите купон.',
        couponDescription1: 'Разовая покупка ≤{amount} C Соins',
        couponDescription2: 'Выполнили 1 заказ(ов)',
        couponDescription3: 'Текущий ход выполнения: {current}/{total}',
        couponDescription4: 'Завершите первое пополнение',
        couponMessage1: 'Ошибка запроса купонов',
        benefitsTab1: 'Награды за вход',
        benefitsTab2: 'Общее количество покупок',
        benefitsTab3: 'Первое пополнение счета',
        benefitsText1: 'Выполняйте задания, чтобы получать награды',
        benefitsText2: 'Войдите в центр пополнения счета',
        benefitsText3: 'Совершите {total} покупок',
        benefitsText4: 'Совершите покупку {current}/{total}',
        benefitsText5: 'Награды за первое пополнение счета',
        usingText1: 'Как использовать C Coins',
        usingText2: 'C Coins можно использовать для покупки всех внутриигровых пакетов, кроме подписок и самих C Coins.',
        orderHeader: 'Незавершенный заказ',
        orderbutton: 'Перейти к оплате',
        orderText1: 'Время заказа (UTC+0)',
        orderText2: 'Персонаж',
        orderText3: 'Сервер',
        orderText4: 'Содержимое товара',
        orderText5: 'Купон',
        orderText6: 'Скидка C Coin',
        orderText7: 'Окончательная цена',
        orderText8: 'Срок действия заказа',
        orderText9: 'Номер заказа',
        orderMessage1: 'Заказ провалился.',
        paymentButton: 'Да, понятно',
        paymentResult1: 'Поздравляем, ваша покупка успешна!',
        paymentResult2: 'К сожалению, покупка не удалась!',
        loginMessage1: 'Ошибка регистрации',
        addToDesktop: 'Добавить на рабочий стол',
        htmlText1: '<h3>Вопрос 1: Что такое C Coin и для чего она используется?</h3><p>Ответ: C Coin - это внутриигровая валюта City of Crime, которую можно использовать для всех покупок, кроме подписки и самих C Coins.</p><h3>Вопрос 2: Почему я не могу использовать C Coin для покупки пакетов? Почему я не могу найти C Coin-магазин?</h3><p>Возможные причины:</p><p>1. Вы никогда раньше не покупали C Coin. Когда ваш баланс C Coin превысит 0, вы сможете использовать C Coin для совершения покупок в игре.<br>2. Версия вашей платформы в настоящее время не поддерживает платежи C Coin.</p><h3>Вопрос 3: Как я могу использовать купоны?</h3><p>Ответ: Если у вас есть купон, он вступит в силу при создании заказа. Вы также можете выбрать оплату без использования купонов.Пожалуйста, не используйте купоны повторно. Это приведет к сбою отправки.</p><h3>Вопрос 4: Истекает ли срок действия купонов?</h3><p>Ответ: Каждый купон имеет разный срок действия и может быть использован только один раз в течение срока действия. Пожалуйста, не забудьте воспользоваться купонами до истечения срока их действия.</p><h3>Вопрос 5: Можно ли использовать купоны в сочетании со скидками?</h3><p>Ответ: Нет. В большинстве случаев вы можете использовать только одну скидку или купон на каждый заказ. Особые случаи рассматриваются отдельно.</p><h3>Вопрос 6: Почему версия платформы, которую я использую, не поддерживает платежи C Coin?</h3><p>Ответ: На текущем этапе пробной версии только определенные версии платформы поддерживают покупку C Coin. Постепенно будет доступно больше платформ в зависимости от будущей ситуации. Пожалуйста, оставайтесь с нами и следите за обновлениями.</p>',
        termsOfService: 'Условия услуг',
        privacyPolicy: 'Конфиденциальность',
    },
    id: {
        title: 'Pusat Topup Resmi CITY OF CRIME',
        language: 'Indonesia',
        userLevel: 'Lv',
        userServer: 'Server',
        switchAccount: 'Ganti Akun',
        vipBenefits: 'Keuntungan VIP',
        enterID: 'Masukkan BOSS ID',
        login: 'Log in',
        loginFirst: 'Silakan log masuk dulu',
        ok: 'Setuju',
        total: 'Total',
        purchaseNow: 'Beli Sekarang',
        noData: 'Tidak ada data',
        loading: 'Memuatkan……',
        selectPaymentTips: 'Silakan pilih metode pembayaran',
        selectGoodsTips: 'Silakan pilih barang',
        uidTips: 'Anda bisa menekan tombol avatar dalam game yang berada di pojok atas kiri untuk menemukan UID Anda.',
        coinTips: 'C Coin bisa digunakan untuk membeli semua layanan bernilai terkecuali konten berlangganan dan C Coin itu sendiri',
        orderTips: 'Anda memiliki pesanan yang belum selesai',
        heading1: 'Pusat Bonus',
        heading2: 'Kupon',
        heading3: 'Opsi Topup',
        heading4: 'Pilih metode pembayaran',
        heading5: 'Pertanyaan Umum',
        couponTab1: 'Kuponku',
        couponTab2: 'Kupon yang bisa diambil',
        couponText1: 'Periksa kupon setelah log in',
        couponText2: 'Penawaran rekomendasi dipilih',
        couponText3: 'Tidak ada penawaran yang bisa digunakan',
        couponText4: 'Diskon tidak bisa ditumpuk',
        couponText5: 'Silakan pilih kupon',
        couponDescription1: 'Topup Tunggal ≤{amount} C Coin',
        couponDescription2: 'Selesaikan 1 Topup Tunggal ',
        couponDescription3: 'Kemajuan penyelesaian saat ini: {current}/{total}',
        couponDescription4: 'Selesaikan Topup Pertama',
        couponMessage1: 'Pertanyaan kupon gagal',
        benefitsTab1: 'Hadiah Log in',
        benefitsTab2: 'Akumulasi Topup',
        benefitsTab3: 'Topup pertama kali',
        benefitsText1: 'Selesaikan misi untuk mendapatkan hadiah',
        benefitsText2: 'Log in ke Pusat Topup',
        benefitsText3: 'Akumulasi Topup {total}x',
        benefitsText4: 'Sudah Topup {current}/{total}x',
        benefitsText5: 'Hadiah Topup pertama kali',
        usingText1: 'Bagaimana menggunakan C Coin',
        usingText2: 'C Coin bisa digunakan untuk membeli paket apapun di dalam game terkecuali konten berlangganan dan C Coin itu sendiri.',
        orderHeader: 'Pesanan Belum Selesai',
        orderbutton: 'Bayar',
        orderText1: 'Waktu pemesanan (UTC+0)',
        orderText2: 'Karakter',
        orderText3: 'Server',
        orderText4: 'Isi Produk',
        orderText5: 'Kupon',
        orderText6: 'Rabat C Coin',
        orderText7: 'Harga Akhir',
        orderText8: 'Masa Berlaku Pesanan',
        orderText9: 'Nomor pesanan',
        orderMessage1: 'Perintah gagal',
        paymentButton: 'Iya, Mengerti',
        paymentResult1: 'Selamat! Top-Up berhasil!',
        paymentResult2: 'Maaf! Top-Up Gagal!',
        loginMessage1: 'Login gagal',
        addToDesktop: 'Tambahkan ke desktop',
        htmlText1: '<h3>P1: Apa itu C Coin, dan apa kegunaannya?</h3><p>J: C Coin adalah mata uang di dalam game City of Crime dan bisa digunakan sebagai pengganti uang untuk membeli semua layanan bernilai di dalam game terkecuali konten berlangganan dan C Coin itu sendiri.</p><h3>P2: Kenapa saya tidak bisa menggunakan C Coin untuk membeli paket atau kenapa saya tidak bisa melihat mall C Coin?</h3><p>J: Kemungkinan dikarenakan hal berikut:</p><p>1. Anda belum topup C Coin. Hanya saat saldo C Coin Anda diatas 0 baru bisa menggunakan pembayaran C Coin<br>2. Versi platformi yang kamu gunakan belum mendukung pembayaran dengan C Coin.</p><h3>P3: Bagaimana menggunakan kupon?</h3><p>J: Jika kamu memiliki kupon, kupon akan efektif ketika kamu membuat pesanan. Kamu juga bisa memilih untuk tidak menggunakan kupon.Mohon untuk tidak menggunakan ulang kupon. Hal ini bisa menyebabkan kegagalan pengiriman.</p><h3>P4: Apakah kupon berlaku untuk waktu yang lama?</h3><p>J: Setiap kupon memiliki waktu kedaluwarsa yang berbeda dan hanya bisa digunakan sekali dalam masa berlaku. Harap gunakan kupon dalam masa berlaku.</p><h3>P5: Apakah kupon bisa digunakan dalam waktu yang bersamaan dengan diskon?</h3><p>J: Tidak. Umumnya hanya satu kebijakan diskon per pesanan. Kondisi khusus akan dijelaskan secara terpisah.</p><h3>P6: Mengapa versi platform yang saya gunakan tidak bisa membeli C Coin?</h3><p>J: Saat tahap operasi uji coba, hanya platform tertentu yang mendukung pembelian. Lebih banyak platform akan tersedia secara bertahap berdasarkan kondisi operasional, stay tuned.</p>',
        termsOfService: 'Ketentuan Layanan',
        privacyPolicy: 'Kebijakan Privasi',
    },
    pt: {
        title: 'Centro Oficial de Recarga da CIDADE DO CRIME',
        language: 'Português',
        userLevel: 'Nv',
        userServer: 'Servidor',
        switchAccount: 'Troca de contas',
        vipBenefits: 'Benefícios VIP',
        enterID: 'Digite BOSS ID',
        login: 'Iniciar sessão',
        loginFirst: 'Por favor, faça o login primeiro',
        ok: 'Concordo',
        total: 'Total',
        purchaseNow: 'Compre agora',
        noData: 'Não há dados disponíveis',
        loading: 'Carregamento……',
        selectPaymentTips: 'Seleccione por favor o método de pagamento',
        selectGoodsTips: 'Por favor, selecione os produtos',
        uidTips: 'Você pode encontrar seu UID no jogo ao clicar no botão do seu avatar no canto superior esquerdo.',
        coinTips: 'A C Coin pode ser usada para comprar todos os serviços de valor agregado do Jogo que podem ser recarregados ou comprados, exceto a C Coin e os Serviços de Assinatura.',
        orderTips: 'Tem pedidos pendentes',
        heading1: 'Centro de Bônus',
        heading2: 'Cupom',
        heading3: 'Opção de Recarga',
        heading4: 'Selecionar método de pagamento',
        heading5: 'Perguntas frequentes',
        couponTab1: 'Meus cupons',
        couponTab2: 'Cupons disponíveis',
        couponText1: 'Faça login para ver os cupons',
        couponText2: 'Ofertas selecionadas',
        couponText3: 'Nenhuma oferta disponível',
        couponText4: 'As ofertas de desconto não podem ser acumuladas',
        couponText5: 'Seleccione um cupão',
        couponDescription1: 'Recarga única ≤{amount} C Coins',
        couponDescription2: 'Concluídos 1 pedido(s)',
        couponDescription3: 'Evolução actual da conclusão: {current}/{total}',
        couponDescription4: 'Concluir a Primeira Recarga',
        couponMessage1: 'A consulta do cupão falhou',
        benefitsTab1: 'Recompesa de login',
        benefitsTab2: 'Acumulação de Recarga',
        benefitsTab3: 'Recarga pela primeira vez',
        benefitsText1: 'Receba recompensas por concluir tarefas',
        benefitsText2: 'Faça login no Centro de Recarga',
        benefitsText3: 'Recarga acumulada {total} vezes',
        benefitsText4: 'Recarregado {current}/{total} vezes',
        benefitsText5: 'Recompesa de recarga pela primeira vez',
        usingText1: 'Como usar C Coins',
        usingText2: 'As C Coins podem ser usadas para comprar qualquer pacote de presente no jogo, exceto assinaturas e as próprias C Coins.',
        orderHeader: 'Pedidos pendentes',
        orderbutton: 'Vá e pague',
        orderText1: 'Hora do pedido (UTC+0)',
        orderText2: 'Charáter',
        orderText3: 'Servidor',
        orderText4: 'Conteúdo do produto',
        orderText5: 'Cupom',
        orderText6: 'Retorno de carga de C Coin',
        orderText7: 'Preço final',
        orderText8: 'Data de expiração do pedido',
        orderText9: 'número de série',
        orderMessage1: 'A encomenda falhou',
        paymentButton: 'Entendido.',
        paymentResult1: 'Parabéns! Recarga bem-sucedida!',
        paymentResult2: 'Infelizmente, a compra falhou!',
        loginMessage1: 'A autenticação falhou',
        addToDesktop: 'Adicionar à área de trabalho',
        htmlText1: '<h3>P1: O que é C Coin e para que é usada?</h3><p>R: C Coin é a moeda emitida pelo jogo City of Crime e pode ser usada para comprar todos os serviços de valor agregado do jogo, exceto C Coin e conteúdo de assinatura, em vez de dinheiro.</p><h3>P2: Por que não consigo usar C Coin para comprar pacotes ou por que não consigo ver o C Coin Mall?</h3><p>Resposta:Isso pode ocorrer pelos seguintes motivos:</p><p>1. Você não reabasteceu a moeda; você pode usar a moeda para pagar no jogo quando seu saldo de moedas for maior que 0.<br>2. A versão da plataforma que você está usando não suporta o uso de pagamento em moedas por enquanto.</p><h3>P3: Como usar o cupom?</h3><p>R: Se você tiver um cupom, ele entrará em vigor automaticamente quando você criar um pedido. Ao mesmo tempo, você também pode optar por não usar o cupom. cupom para liquidação.Não use o cupom repetidamente, caso contrário, a entrega poderá falhar.</p><h3>P4: O cupom é válido por muito tempo?</h3><p>R: Cada cupom tem uma data de validade diferente e só pode ser usado uma vez dentro da data de validade.Por favor, use-o em tempo hábil.</p><h3>P5: Os cupons são compartilhados com descontos?</h3><p>R: Não, não compartilhamos descontos. Normalmente, você só pode aproveitar um desconto por pedido, mas circunstâncias especiais serão explicadas separadamente.</p><h3>P6: Por que minha versão da plataforma não é compatível com a C Coin?</h3><p>R: Apenas algumas versões da plataforma são suportadas no estágio de operação de teste e serão abertas gradualmente de acordo com a situação da operação. Por favor, aguarde.</p>',
        termsOfService: 'Termos de Serviço',
        privacyPolicy: 'Política de Privacidade',
    },
    jp: {
        title: 'CITY OF CRIME 公式チャージセンター',
        language: '日本語',
        userLevel: 'Lv',
        userServer: 'サーバー',
        switchAccount: 'アカウント切り替え',
        vipBenefits: 'VIP特典',
        enterID: 'ボスのIDを入力してください',
        login: 'ログイン',
        loginFirst: '先にログインしてください',
        ok: 'はい',
        total: '合計',
        purchaseNow: 'すぐ購入',
        noData: 'データなし',
        loading: 'ロード中……',
        selectPaymentTips: '支払い方法を選択してください',
        selectGoodsTips: '商品を選択してください',
        uidTips: 'ゲーム内で自分のUIDを確認するには、左上のアバターをクリックしてください。',
        coinTips: 'C コインは、C コインおよびサブスクリプションサービスを除き、ゲーム内チャージまたは購入可能な全部付加価値サービスの購入に使用できます。',
        orderTips: '未払い注文があります',
        heading1: '特典センター',
        heading2: 'クーポン',
        heading3: 'チャージランク',
        heading4: '支払いタイプを選択してください',
        heading5: 'よくあるチャージ質問FAQ',
        couponTab1: 'マイクーポン',
        couponTab2: 'クーポンを受取れます',
        couponText1: 'ログインしてクーポンを見る',
        couponText2: 'お勧めの特典を選びました',
        couponText3: '使用可能な特典はありません',
        couponText4: '割引の併用はできません',
        couponText5: 'クーポンをお選びください',
        couponDescription1: 'シングルチャージ ≤{amount} C Coinsc',
        couponDescription2: '1 回注文',
        couponDescription3: '現在の完了状況: {current}/{total}',
        couponDescription4: '初回チャージを完了する',
        couponMessage1: 'クーポン照会に失敗しました',
        benefitsTab1: 'ログインボーナス',
        benefitsTab2: 'チャージ総額',
        benefitsTab3: '初回チャージ',
        benefitsText1: 'ミッションを完了すると報酬を獲得できます',
        benefitsText2: 'チャージセンターにログイン',
        benefitsText3: '合計チャージ {total} 回',
        benefitsText4: '{current}/{total} 回をチャージしました',
        benefitsText5: '初回チャージボーナス',
        usingText1: 'C コインの使い方',
        usingText2: 'C コインは、サブスクリプションとC コイン以外のゲーム内パックの購入に使用できます。',
        orderHeader: '未払いの注文',
        orderbutton: '購入',
        orderText1: '注文時刻（UTC+0）',
        orderText2: 'キャラクター',
        orderText3: 'サーバー',
        orderText4: '商品内容',
        orderText5: 'クーポン',
        orderText6: 'C コインのリベート',
        orderText7: '最終価格',
        orderText8: '注文の有効期限',
        orderText9: '注文番号',
        orderMessage1: '注文に失敗しました',
        paymentButton: 'はい、承りました',
        paymentResult1: 'おめでとうございます！チャージ成功！',
        paymentResult2: '誠に申し訳ございません、チャージ失敗！',
        loginMessage1: 'ログインに失敗しました',
        addToDesktop: 'デスクトップに追加',
        htmlText1: '<h3>Q1:C コインとは何ですか？</h3><p>答え:C コインとは、「City of Crime」ゲーム内で発行される通貨で、C コインとサブスクリプションコンテンツを除く、ゲーム内のすべての付加価値サービスを購入する際に、現金の代わりに使用することができます。</p><h3>Q2:C コインでパックが買えない、C コインショップが表示されないのはなぜですか？</h3><p>答え：以下の原因が考えられます。</p><p>1.C コインをチャージされたことがありません。ゲーム内での支払いは、C コインの残高が0以上の場合にのみ可能です。<br>2.お使いのプラットフォームのバージョンがC コイン決済をサポートしていません。</p><h3>Q3:クーポンの使い方を教えてください。</h3><p>答え:クーポンをお持ちの場合、注文が作成される際に自動的に有効となります。 同時に、クーポンなしで決済することも可能です。商品の出荷に失敗するおそれがありますので、クーポンの二重使用はご遠慮ください。</p><h3>Q4:クーポンの有効期限はありますか？</h3><p>答え:クーポンにはそれぞれ有効期限があり、有効期限内に1回のみご利用いただけますので、有効期限内にご利用ください。</p><h3>Q5:クーポンと割引の併用はできますか？</h3><p>答え:クーポンと割引の併用はできません。 通常、割引は1回のご注文につき1回のみですが、特別な場合は別途ご説明いたします。</p><h3>Q6:使用しているプラットフォームのバージョンがC コインのチャージに対応していないのはなぜですか？</h3><p>答え:試験運用段階では一部のプラットフォームバージョンにのみ対応しており、運用状況に応じて順次オープンしていきますので、楽しみにお待ちください。</p>',
        termsOfService: '利用規約',
        privacyPolicy: 'プライバシーポリシー',
    },
    ko: {
        title: 'CITY OF CRIME 공식 충전 센터',
        language: '한국어',
        userLevel: '레벨',
        userServer: '서버',
        switchAccount: '계정 전환',
        vipBenefits: 'VIP 특권',
        enterID: 'BOSS ID를 입력해 주세요',
        login: '로그인',
        loginFirst: '먼저 로그인하십시오.',
        ok: '네',
        total: '합계',
        purchaseNow: '즉시 구매',
        noData: '데이터 없음',
        loading: '로드 중……',
        selectPaymentTips: '결제 방법을 선택하십시오.',
        selectGoodsTips: '상품을 선택하십시오.',
        uidTips: '게임 내 좌측 상단의 프로필을 클릭해 UID를 확인할 수 있습니다.',
        coinTips: 'C 코인은 게임내의 구독 및 C 코인을 제외한 모든 패키지를 구매하는데 사용할 수 있습니다.',
        orderTips: '완료하지 못한 결제 내역이 있습니다.',
        heading1: '보너스 센터',
        heading2: '할인 쿠폰',
        heading3: '충전 금액',
        heading4: '결제 방식을 선택해주세요',
        heading5: '자주 묻는 충전 문제 FAQ',
        couponTab1: '내 할인 쿠폰',
        couponTab2: '할인 쿠폰 수령 가능',
        couponText1: '로그인 후 할인 쿠폰 확인',
        couponText2: '추천 할인 선택 완료',
        couponText3: '사용 가능한 할인 없음',
        couponText4: '중복 할인은 불가능 합니다',
        couponText5: '쿠폰을 선택하십시오.',
        couponDescription1: '단일 충전 ≤{amount} C Coins',
        couponDescription2: '충전 완료 1 건',
        couponDescription3: '현재 완료 진행률: {current}/{total}',
        couponDescription4: '첫 충전 완료',
        couponMessage1: '쿠폰 쿼리 실패',
        benefitsTab1: '로그인 보상',
        benefitsTab2: '누적 충전',
        benefitsTab3: '첫 충전',
        benefitsText1: '임무 완료시 보상 획득',
        benefitsText2: '충전 센터 로그인',
        benefitsText3: '누적 충전 {total} 회',
        benefitsText4: '충전 횟수 {current}/{total} 회',
        benefitsText5: '첫 충전 보상',
        usingText1: '어떻게 C 코인을 사용하나요?',
        usingText2: 'C 코인은 게임내의 구독 및 C 코인을 제외한 모든 패키지를 구매하는데 사용할 수 있습니다.',
        orderHeader: '결제 주문 미완료',
        orderbutton: '구매하기',
        orderText1: '결제 시간(UTC+0)',
        orderText2: '캐릭터',
        orderText3: '서버',
        orderText4: '상품 정보',
        orderText5: '할인 쿠폰',
        orderText6: 'C 코인 리베이트',
        orderText7: '최종 가격',
        orderText8: '결제 유효 기간',
        orderText9: '주문 번호',
        orderMessage1: '주문 실패',
        paymentButton: '네, 알겠습니다',
        paymentResult1: '축하합니다! 충전에 성공하셨습니다!',
        paymentResult2: '죄송합니다! 충전에 실패하셨습니다!',
        loginMessage1: '로그인 실패',
        addToDesktop: '바탕 화면에 추가',
        htmlText1: '<h3>Q1: C 코인은 무엇인가요?<h3><p>답: C 코인은 City of Crime 게임 내에서 발행한 화폐이며, 게임내의 C 코인 및 구독상품을 제외한 상품 구매에 사용할 수 있습니다.</p><h3>Q2: 왜 전 C 코인으로 패키지를 구매할 수 없나요? 또는 왜 저는 C 코인 상점이 안보이나요?<h3><p>답: 일반적인 구매할 수 없는 이유:</p><p>1. C 코인을 충전한 적이 없기때문입니다. 남은 C 코인이 0을 초과할 경우, 게임 내에서 C 코인을 구매에 사용할 수 있습니다.<br>2. 다운로드를 받은 스토어에서 C 코인을 지원하지 않기 때문입니다.</p><h3>Q3:할인 쿠폰은 어떻게 사용하나요?</h3><p>답: 할인 쿠폰을 보유하고 있으면, 결제시 자동으로 사용하게 되며, 원하지 않을 경우 선택을 취소하여 구매할 수도 있습니다. 할인 쿠폰 중복 사용 시 결제 오류가 발생할 수 있습니다.</p><h3>Q4:할인 쿠폰은 유효기간이 따로 있나요?</h3><p>답: 모든 할인 쿠폰의 유효기간은 전부 다르며, 사용 가능 기간동안 1회만 사용할 수 있습니다.</p><h3>Q5:할인 쿠폰은 다른 할인과 동시에 적용되나요?<h3><p>답: 동시에 적용되지 않습니다, 할인 정책에 따라 주문 상품당 1회만 할인 적용이 가능합니다. 특수 상황시 따로 추가 설명이 들어갈 예정입니다.</p><h3>Q6:스토어에 따라 C 코인 사용 여부가 다른 이유는 무엇인가요?</h3><p>답: 시험 운영단계에는 일부 스토어에서만 C 코인을 지원하게 되며, 추후 다른 스토어에서도 C 코인을 만나 보실 수 있습니다.</p>',
        termsOfService: '이용 약관',
        privacyPolicy: '개인정보 동의',
    },
}
export default messages;